export async function createLeaderboardAggregates(gymStateDb: any, logger: any) {
  logger.info('create leaderboard aggregates view index');

  const doc = {
    _id: '_design/leaderboard',
    views: {
      'leaderboard-aggregates': {
        map: `function(doc) {
          if (!doc.removedAt && doc.leaderboards && doc.leaderboards.length > 0) {
            for (var i = 0; i < doc.leaderboards.length; i++) {
              var leaderboard = doc.leaderboards[i];
              var metric = leaderboard.metric;
              if (leaderboard.calculatedScore) {
                emit([leaderboard.metric, leaderboard.leaderboardId, leaderboard.startDate,
                   leaderboard.endDate, leaderboard.team, doc.userProfileId], leaderboard.calculatedScore);
              }
              else if (metric === 'effort-points' && doc.performanceMetrics && doc.performanceMetrics.load) {
                emit([leaderboard.metric, leaderboard.leaderboardId, leaderboard.startDate,
                 leaderboard.endDate, leaderboard.team, doc.userProfileId], doc.performanceMetrics.load);
              }
              else if (metric === 'total-minutes' || metric === 'average-minutes') {
                var startTimeOfFirstExerciseInMs = new Date(doc.startTimeOfFirstExercise).getTime();
                var endTimeOfWorkoutInMs = new Date(doc.endTime).getTime();
                var additionalSecondsBeforeFirstExerciseInMs =
                 ((doc.additionalSecondsBeforeFirstExercise || 0) * 1000);

                var totalMinutes = Math.round(
                  (endTimeOfWorkoutInMs - startTimeOfFirstExerciseInMs -
                   additionalSecondsBeforeFirstExerciseInMs) / 60000
                );

                if (totalMinutes > 0) {
                  emit([leaderboard.metric, leaderboard.leaderboardId, leaderboard.startDate,
                   leaderboard.endDate, leaderboard.team, doc.userProfileId], totalMinutes);
                }
              }
            }
          }
        }`,
        reduce: '_sum',
      },
      'user-leaderboards': {
        map: `function(doc) {
           if (!doc.removedAt && doc.leaderboards && doc.leaderboards.length > 0) {
            for (var i = 0; i < doc.leaderboards.length; i++) {
              var leaderboard = doc.leaderboards[i];

            if (leaderboard.metric === 'effort-points') {
              if (doc.performanceMetrics && doc.performanceMetrics.load && doc.performanceMetrics.load > 0) {
                emit([doc.userProfileId, leaderboard.startDate, leaderboard.endDate, leaderboard.leaderboardId], null);
              }
              continue;
            }

            emit([doc.userProfileId, leaderboard.startDate, leaderboard.endDate, leaderboard.leaderboardId], null);
            }
          }
        }`,
        reduce: '_count',
      },
      'leaderboard-instances': {
        map: `function(doc) {
          if (!doc.removedAt && doc.leaderboards && doc.leaderboards.length > 0) {
            for (var i = 0; i < doc.leaderboards.length; i++) {
              var leaderboard = doc.leaderboards[i];

             if (leaderboard.metric === 'effort-points') {
                if (doc.performanceMetrics && doc.performanceMetrics.load && doc.performanceMetrics.load > 0) {
                  emit([leaderboard.leaderboardId, leaderboard.metric, leaderboard.startDate, leaderboard.endDate ], 1);
                }
                continue;
              }

              emit([leaderboard.leaderboardId, leaderboard.metric, leaderboard.startDate, leaderboard.endDate ], 1);
            }
          }
        }`,
        reduce: '_count',
      },
    },
  };

  await gymStateDb.put(doc);
}
